import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../libs/shared/helpers/src/internationalization/react';
import {ClickEventHandler} from '../../../libs/shared/helpers/src/react/reactHelpers';
import {Button} from '../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {VisualSizesEnum} from '../../../libs/shared/ui/src/styles/commonStyles';
import {fontSizes, fontWeights} from '../../../libs/shared/ui/src/styles/fontStyles';
import {PaletteColorsEnum} from '../../../libs/shared/ui/src/styles/paletteModel';
import {boxShadow} from '../../../libs/shared/ui/src/theme/themeStyleHelpers';

/*
 * Props.
 */

interface RequestInviteButtonV3Props {
  wasInviteRequested: boolean;
  onClick: ClickEventHandler;
}

/*
 * Style.
 */

const StyledContentDiv = styled.div`
  width: 196px;
`;

const StyledButtonDiv = styled.div`
  border-radius: 14px;
  overflow: hidden;
  ${(p) => boxShadow(p.theme, `0px 3px 14px rgba(26, 76, 168, 0.2)`)};
  & [role='button'] > div {
    transition: background-color 250ms linear;
  }
  max-width: 238px;
  margin-top: 4px;
`;

const StyledSuccessStateDiv = styled.div`
  border-radius: 14px;
  width: 300px;
  line-height: 20px;
  font-weight: ${fontWeights.semibold};
  font-size: ${fontSizes.large};
  color: ${(p) => p.theme.palette[PaletteColorsEnum.GREEN].shade50};
  background: ${(p) => p.theme.palette[PaletteColorsEnum.GREEN].shade10};
  display: flex;
  justify-content: center;
  & > :first-child {
    margin-left: 8px;
  }
  max-width: 238px;
  margin-top: 4px;
  padding: 9px 16px;
`;

/*
 * Component.
 */

export const RequestInviteButtonV3: FC<RequestInviteButtonV3Props> = ({wasInviteRequested, onClick}) => {
  if (wasInviteRequested) {
    return (
      <StyledSuccessStateDiv>
        <Trans id="visitor-sidebar-button-requestinvite-sent">Request sent</Trans>
      </StyledSuccessStateDiv>
    );
  }

  return (
    <StyledButtonDiv>
      <Button onClick={onClick} size={VisualSizesEnum.LARGE} variant={ButtonVariantsEnum.PRIMARY}>
        <StyledContentDiv>
          <Trans id="visitor-sidebar-button-requestinvite-v3">Ask to be added</Trans>
        </StyledContentDiv>
      </Button>
    </StyledButtonDiv>
  );
};
